import BuyerIcon from '@/components/icons/buyer-icon';
import MapsPinIcon from '@/components/icons/maps-pin-icon';
import OrderIcon from '@/components/icons/order-icon';
import ProfileIcon from '@/components/icons/profile-icon';
import ButtonLogout from '@/components/sections/customer/store/button-logout';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useRouter } from 'next/navigation';

export function UserNav() {
  const router = useRouter();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className='hover:cursor-pointer'>
          <BuyerIcon className='h-7 w-7 ' data-test='buyer-icon' />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent className='z-[105] w-56' align='end' forceMount>
        <DropdownMenuGroup>
          <DropdownMenuItem onClick={() => router.push('/account')} data-testid='profile-icon'>
            <ProfileIcon className='mr-2 h-4 w-4' /> My Profile
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => router.push('/account/order')} data-testid='order-icon'>
            <OrderIcon className='mr-2 h-4 w-4' /> My Orders
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => router.push('/account/address')}
            data-testid='address-icon'
          >
            <MapsPinIcon className='mr-2 h-4 w-4' /> My Address
          </DropdownMenuItem>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <ButtonLogout />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
